import { render, staticRenderFns } from "./handleClaimOrder.vue?vue&type=template&id=244f4b02"
import script from "./handleClaimOrder.vue?vue&type=script&lang=js"
export * from "./handleClaimOrder.vue?vue&type=script&lang=js"
import style0 from "./handleClaimOrder.vue?vue&type=style&index=0&id=244f4b02&lang=scss&rel=stylesheet%2Fscss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/.jenkins/workspace/yto-crm-steward-h5/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('244f4b02')) {
      api.createRecord('244f4b02', component.options)
    } else {
      api.reload('244f4b02', component.options)
    }
    module.hot.accept("./handleClaimOrder.vue?vue&type=template&id=244f4b02", function () {
      api.rerender('244f4b02', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/claimWorkOrder/components/handleClaimOrder.vue"
export default component.exports